var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Loader',{attrs:{"value":_vm.promises.fetch}},[_c('div',{staticClass:"residential-page"},[_c('Blocks',{attrs:{"blocks":_vm.config,"custom-components":_vm.customComponents}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }